/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {EventSubscription} from '../models/EventSubscription';

export interface GetSubscriptionsByEventId$Request {
    eventId: number;
}

export interface GetSubscriptionsByEventId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSubscriptionsByEventIdRequest = createAction<PayloadData<void, GetSubscriptionsByEventId$Request>>('EVENT_SUBSCRIPTION_CONTROLLER__GET_SUBSCRIPTIONS_BY_EVENT_ID__REQUEST');
export const getSubscriptionsByEventIdSuccess = createAction<PayloadData<Array<EventSubscription>, GetSubscriptionsByEventId$Request>>('EVENT_SUBSCRIPTION_CONTROLLER__GET_SUBSCRIPTIONS_BY_EVENT_ID__SUCCESS');
export const getSubscriptionsByEventIdFailure = createAction<PayloadData<Error, GetSubscriptionsByEventId$Request, true>>('EVENT_SUBSCRIPTION_CONTROLLER__GET_SUBSCRIPTIONS_BY_EVENT_ID__FAILURE');

export const getSubscriptionsByEventIdActions = [
    getSubscriptionsByEventIdRequest,
    getSubscriptionsByEventIdSuccess,
    getSubscriptionsByEventIdFailure
] as const;

/**
 * @param {number} meta.eventId Event Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSubscriptionsByEventId = (meta: GetSubscriptionsByEventId$Request, config?: GetSubscriptionsByEventId$Config) => {
    return {
        CALL_API: {
            types: getSubscriptionsByEventIdActions,
            method: ApiMethods.GET,
            endpoint: `/event-subscriptions/${meta.eventId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveEventSubscriptionById$Request {
    id: number;
}

export interface RemoveEventSubscriptionById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeEventSubscriptionByIdRequest = createAction<PayloadData<void, RemoveEventSubscriptionById$Request>>('EVENT_SUBSCRIPTION_CONTROLLER__REMOVE_EVENT_SUBSCRIPTION_BY_ID__REQUEST');
export const removeEventSubscriptionByIdSuccess = createAction<PayloadData<void, RemoveEventSubscriptionById$Request>>('EVENT_SUBSCRIPTION_CONTROLLER__REMOVE_EVENT_SUBSCRIPTION_BY_ID__SUCCESS');
export const removeEventSubscriptionByIdFailure = createAction<PayloadData<Error, RemoveEventSubscriptionById$Request, true>>('EVENT_SUBSCRIPTION_CONTROLLER__REMOVE_EVENT_SUBSCRIPTION_BY_ID__FAILURE');

export const removeEventSubscriptionByIdActions = [
    removeEventSubscriptionByIdRequest,
    removeEventSubscriptionByIdSuccess,
    removeEventSubscriptionByIdFailure
] as const;

/**
 * @param {number} meta.id Event Subscription Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeEventSubscriptionById = (meta: RemoveEventSubscriptionById$Request, config?: RemoveEventSubscriptionById$Config) => {
    return {
        CALL_API: {
            types: removeEventSubscriptionByIdActions,
            method: ApiMethods.DELETE,
            endpoint: `/event-subscriptions/remove/${meta.id}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveEventSubscription$Request {
    eventSubscription: EventSubscription;
}

export interface SaveEventSubscription$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveEventSubscriptionRequest = createAction<PayloadData<void, SaveEventSubscription$Request>>('EVENT_SUBSCRIPTION_CONTROLLER__SAVE_EVENT_SUBSCRIPTION__REQUEST');
export const saveEventSubscriptionSuccess = createAction<PayloadData<number, SaveEventSubscription$Request>>('EVENT_SUBSCRIPTION_CONTROLLER__SAVE_EVENT_SUBSCRIPTION__SUCCESS');
export const saveEventSubscriptionFailure = createAction<PayloadData<Error, SaveEventSubscription$Request, true>>('EVENT_SUBSCRIPTION_CONTROLLER__SAVE_EVENT_SUBSCRIPTION__FAILURE');

export const saveEventSubscriptionActions = [
    saveEventSubscriptionRequest,
    saveEventSubscriptionSuccess,
    saveEventSubscriptionFailure
] as const;

/**
 * @param {EventSubscription} meta.eventSubscription
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveEventSubscription = (meta: SaveEventSubscription$Request, config?: SaveEventSubscription$Config) => {
    return {
        CALL_API: {
            types: saveEventSubscriptionActions,
            method: ApiMethods.POST,
            endpoint: `/event-subscriptions/save`,
            TRANSPORT_REQUEST_BODY: meta.eventSubscription,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

